<template>
  <v-app-bar app :style="'background-color: ' + headerBG + ';'">
    <v-toolbar-title class="headline text-uppercase">
      <span :style="'color: ' + headerFontMain">IMMOBILIEN </span>
      <span class="font-weight-light" :style="'color: ' + headerFontSecond">Verkauf Online</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn
      text
      href=""
      target="_blank">
      <span class="mr-2" :style="'color: ' + headerFontMain">Beispiel Text</span>
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  name: 'Header',
  props: {
    headerBG: {
      type: String,
      required: true
    },
    headerFontMain: {
      type: String,
      required: true
    },
    headerFontSecond: {
      type: String,
      required: true
    }
  }
};
</script>
